// ─── messageApi ──────────────────────────────────────────────────────────────
// Wrappers for the Message Center page.
//
//   GET    /api/data/messages/?project_id=<id>[&q=<search>]   list
//   POST   /api/data/messages/                                 create
//   DELETE /api/data/messages/<id>/                            soft-delete

import axios from 'axios'

const API_URL         = import.meta.env.VITE_API_URL          || 'https://wqlive.ezxdemo.com'
const API_BASE_PATH   = import.meta.env.VITE_API_BASE_PATH    || '/api'
const JWT_STORAGE_KEY = import.meta.env.VITE_JWT_STORAGE_KEY  || 'auth_token'

const authHeaders = () => {
    const token = (localStorage.getItem(JWT_STORAGE_KEY) || sessionStorage.getItem(JWT_STORAGE_KEY))
    return {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
    }
}
const getHeaders = () => ({
    ...authHeaders(),
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma':        'no-cache',
    'Expires':       '0',
})

const url = (p) => `${API_URL}${API_BASE_PATH}${p}`

export async function listMessages(projectId, q = '') {
    const params = { project_id: projectId, _t: Date.now() }
    if (q) params.q = q
    const res = await axios.get(url('/data/messages/'), { headers: getHeaders(), params })
    return res.data?.messages || []
}
export async function createMessage({ projectId, body }) {
    const res = await axios.post(url('/data/messages/'),
        { project_id: projectId, body }, { headers: authHeaders() })
    return res.data
}
export async function deleteMessage(messageId) {
    const res = await axios.delete(url(`/data/messages/${messageId}/`),
        { headers: authHeaders() })
    return res.data
}
export async function markMessageRead(messageId) {
    const res = await axios.post(url(`/data/messages/${messageId}/read/`),
        {}, { headers: authHeaders() })
    return res.data
}
export async function markAllRead(projectId) {
    const res = await axios.post(url('/data/messages/read-all/'),
        { project_id: projectId }, { headers: authHeaders() })
    return res.data
}
export async function getNotificationPrefs() {
    const res = await axios.get(url('/data/messages/preferences/'),
        { headers: getHeaders(), params: { _t: Date.now() } })
    return res.data
}
export async function getUnreadCount(projectId) {
    const res = await axios.get(url('/data/messages/unread-count/'), {
        headers: getHeaders(),
        params:  { project_id: projectId, _t: Date.now() },
    })
    return res.data // { project_id, count }
}
export async function updateNotificationPrefs(patch) {
    // patch: { scope?, mute? ('off' | 'until_tomorrow' | '1_hour' | 'custom'),
    //          mute_until_iso? (for custom) }
    const res = await axios.patch(url('/data/messages/preferences/'),
        patch, { headers: authHeaders() })
    return res.data
}
